import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';

export default function RoleEditor({ isDarkMode, onClose }) {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingRole, setEditingRole] = useState(null);
  const [newRole, setNewRole] = useState({
    name: '',
    displayName: '',
    permissions: {
      viewAllUsers: true,
      viewContacts: true,
      viewChat: true,
      viewDashboard: true,
      viewActivities: true,
      viewCommissions: true,
      viewRequests: true,
      viewAdmin: false,
      viewBackup: false,
      editCompanies: true,
      deleteCompanies: false,
      exportData: false,
      manageUsers: false,
      viewStatusEditor: false,
      viewBatchVisibility: false,
      viewKnowledge: false,
      viewContactManagement: false,
      viewMeetingPlanner: true,
      editUserPermissions: false,
      viewTransferHistory: false,
      manageTeamleader: false,
      viewDiscord: false,
      importContacts: false,
      deleteContacts: false,
      transferContacts: false,
      editForecast: true,
      viewAllCompanies: true,
      editOwnCompanies: true,
      editAllCompanies: false
    }
  });

  // Výchozí role
  const defaultRoles = [
    {
      name: 'admin',
      displayName: 'Administrator',
      permissions: {
        viewAllUsers: true,
        viewContacts: true,
        viewChat: true,
        viewDashboard: true,
        viewActivities: true,
        viewCommissions: true,
        viewRequests: true,
        viewAdmin: true,
        viewBackup: true,
        editCompanies: true,
        deleteCompanies: true,
        exportData: true,
        manageUsers: true,
        viewStatusEditor: true,
        viewBatchVisibility: true,
        viewKnowledge: true,
        viewContactManagement: true,
        viewMeetingPlanner: true,
        editUserPermissions: true,
        viewTransferHistory: true,
        manageTeamleader: true,
        viewDiscord: true,
        importContacts: true,
        deleteContacts: true,
        transferContacts: true,
        editForecast: true,
        viewAllCompanies: true,
        editOwnCompanies: true,
        editAllCompanies: true
      }
    },
    {
      name: 'obchodnik',
      displayName: 'Obchodní zástupce',
      permissions: {
        viewAllUsers: true,
        viewContacts: true,
        viewChat: true,
        viewDashboard: true,
        viewActivities: true,
        viewCommissions: true,
        viewRequests: true,
        viewAdmin: false,
        viewBackup: false,
        editCompanies: true,
        deleteCompanies: false,
        exportData: false,
        manageUsers: false,
        viewStatusEditor: false,
        viewBatchVisibility: false,
        viewKnowledge: false,
        viewContactManagement: false,
        viewMeetingPlanner: true,
        editUserPermissions: false,
        viewTransferHistory: false,
        manageTeamleader: false,
        viewDiscord: false,
        importContacts: false,
        deleteContacts: false,
        transferContacts: false,
        editForecast: true,
        viewAllCompanies: true,
        editOwnCompanies: true,
        editAllCompanies: false
      }
    },
    {
      name: 'podpora',
      displayName: 'Podpora',
      permissions: {
        viewAllUsers: true,
        viewContacts: true,
        viewChat: true,
        viewDashboard: true,
        viewActivities: true,
        viewCommissions: false,
        viewRequests: true,
        viewAdmin: false,
        viewBackup: false,
        editCompanies: true,
        deleteCompanies: false,
        exportData: false,
        manageUsers: false,
        viewStatusEditor: false,
        viewBatchVisibility: false,
        viewKnowledge: false,
        viewContactManagement: true,
        viewMeetingPlanner: true,
        editUserPermissions: false,
        viewTransferHistory: true,
        manageTeamleader: false,
        viewDiscord: false,
        importContacts: false,
        deleteContacts: false,
        transferContacts: true,
        editForecast: false,
        viewAllCompanies: true,
        editOwnCompanies: true,
        editAllCompanies: false
      }
    },
    {
      name: 'callcentrum',
      displayName: 'Callcentrum',
      permissions: {
        viewAllUsers: true,
        viewContacts: true,
        viewChat: true,
        viewDashboard: false,
        viewActivities: false,
        viewCommissions: false,
        viewRequests: false,
        viewAdmin: false,
        viewBackup: false,
        editCompanies: true,
        deleteCompanies: false,
        exportData: false,
        manageUsers: false,
        viewStatusEditor: false,
        viewBatchVisibility: false,
        viewKnowledge: false,
        viewContactManagement: false,
        viewMeetingPlanner: true,
        editUserPermissions: false,
        viewTransferHistory: false,
        manageTeamleader: false,
        viewDiscord: false,
        importContacts: false,
        deleteContacts: false,
        transferContacts: false,
        editForecast: false,
        viewAllCompanies: false,
        editOwnCompanies: true,
        editAllCompanies: false
      }
    },
    {
      name: 'test',
      displayName: 'Testovací účet',
      permissions: {
        viewAllUsers: false, // Klíčové - nevidí jiné uživatele
        viewContacts: true,
        viewChat: true, // Může používat AI a skupinový chat
        viewDashboard: true,
        viewActivities: true,
        viewCommissions: false,
        viewRequests: false,
        viewAdmin: true, // Změněno na true pro test správy uživatelů
        viewBackup: false,
        editCompanies: true,
        deleteCompanies: false,
        exportData: false,
        manageUsers: true, // Změněno na true pro test správy uživatelů
        viewStatusEditor: false,
        viewBatchVisibility: false,
        viewKnowledge: false,
        viewContactManagement: false,
        viewMeetingPlanner: true,
        editUserPermissions: false,
        viewTransferHistory: false,
        manageTeamleader: false,
        viewDiscord: false,
        importContacts: false,
        deleteContacts: false,
        transferContacts: false,
        editForecast: true,
        viewAllCompanies: false,
        editOwnCompanies: true,
        editAllCompanies: false
      }
    },
    {
      name: 'database',
      displayName: 'Databázový uživatel (skrytý)',
      permissions: {
        viewAllUsers: false,
        viewContacts: false,
        viewChat: false,
        viewDashboard: false,
        viewActivities: false,
        viewCommissions: false,
        viewRequests: false,
        viewAdmin: false,
        viewBackup: false,
        editCompanies: false,
        deleteCompanies: false,
        exportData: false,
        manageUsers: false,
        viewStatusEditor: false,
        viewBatchVisibility: false,
        viewKnowledge: false,
        viewContactManagement: false,
        viewMeetingPlanner: false,
        editUserPermissions: false,
        viewTransferHistory: false,
        manageTeamleader: false,
        viewDiscord: false,
        importContacts: false,
        deleteContacts: false,
        transferContacts: false,
        editForecast: false,
        viewAllCompanies: false,
        editOwnCompanies: false,
        editAllCompanies: false
      },
      hidden: true // Speciální příznak pro skrytí před běžnými uživateli
    }
  ];

  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/roles`);
      
      if (response.ok) {
        const data = await response.json();
        setRoles(data.length > 0 ? data : defaultRoles);
      } else {
        // Pokud endpoint neexistuje, použij výchozí role
        setRoles(defaultRoles);
      }
    } catch (error) {
      console.error('Chyba při načítání rolí:', error);
      setRoles(defaultRoles);
    } finally {
      setLoading(false);
    }
  };

  const saveRoles = async (rolesToSave) => {
    try {
      const response = await fetch(`${API_URL}/roles`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ roles: rolesToSave })
      });
      
      if (response.ok) {
        alert('Role byly úspěšně uloženy! Stránka se obnoví pro načtení nových oprávnění.');
        // Vymazat cache oprávnění a obnovit stránku
        localStorage.removeItem('crm_roles');
        // Obnovit stránku aby se načetly nové role
        window.location.reload();
      } else {
        throw new Error('Chyba při ukládání rolí na server');
      }
    } catch (error) {
      console.error('Chyba při ukládání rolí:', error);
      alert('Chyba při ukládání rolí na server. Zkuste to prosím znovu.');
    }
  };

  const handleSaveRole = () => {
    if (!newRole.name.trim() || !newRole.displayName.trim()) {
      alert('Vyplňte název a zobrazovaný název role');
      return;
    }

    const updatedRoles = editingRole
      ? roles.map(role => role.name === editingRole.name ? newRole : role)
      : [...roles, newRole];

    setRoles(updatedRoles);
    saveRoles(updatedRoles);
    setEditingRole(null);
    setNewRole({
      name: '',
      displayName: '',
      permissions: {
        viewAllUsers: true,
        viewContacts: true,
        viewChat: true,
        viewDashboard: true,
        viewActivities: true,
        viewCommissions: true,
        viewRequests: true,
        viewAdmin: false,
        viewBackup: false,
        editCompanies: true,
        deleteCompanies: false,
        exportData: false,
        manageUsers: false,
        viewStatusEditor: false,
        viewBatchVisibility: false,
        viewKnowledge: false,
        viewContactManagement: false,
        viewMeetingPlanner: true,
        editUserPermissions: false,
        viewTransferHistory: false,
        manageTeamleader: false,
        viewDiscord: false,
        importContacts: false,
        deleteContacts: false,
        transferContacts: false,
        editForecast: true,
        viewAllCompanies: true,
        editOwnCompanies: true,
        editAllCompanies: false
      }
    });
  };

  const handleEditRole = (role) => {
    setEditingRole(role);
    setNewRole({ ...role });
  };

  const handleDeleteRole = (roleName) => {
    if (['admin', 'obchodnik', 'podpora', 'callcentrum', 'test'].includes(roleName)) {
      alert('Základní role nelze smazat');
      return;
    }

    if (window.confirm(`Opravdu chcete smazat roli "${roleName}"?`)) {
      const updatedRoles = roles.filter(role => role.name !== roleName);
      setRoles(updatedRoles);
      saveRoles(updatedRoles);
    }
  };

  const togglePermission = (permission) => {
    setNewRole(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [permission]: !prev.permissions[permission]
      }
    }));
  };

  const getPermissionLabel = (permission) => {
    const labels = {
      viewAllUsers: 'Vidět všechny uživatele',
      viewContacts: 'Přístup ke kontaktům',
      viewChat: 'Přístup k chatu',
      viewDashboard: 'Přístup k dashboardu',
      viewActivities: 'Přístup k aktivitám',
      viewCommissions: 'Přístup k provizím',
      viewRequests: 'Přístup k požadavkům',
      viewAdmin: 'Přístup k admin panelu',
      viewBackup: 'Přístup k zálohování',
      editCompanies: 'Editace firem',
      deleteCompanies: 'Mazání firem',
      exportData: 'Export dat',
      manageUsers: 'Správa uživatelů',
      viewStatusEditor: 'Editor stavů',
      viewBatchVisibility: 'Správa viditelnosti šarží',
      viewKnowledge: 'Správa znalostí',
      viewContactManagement: 'Správa kontaktů',
      viewMeetingPlanner: 'Plánovač schůzek',
      editUserPermissions: 'Editace oprávnění uživatelů',
      viewTransferHistory: 'Historie převodů',
      manageTeamleader: 'Správa teamleaderů',
      viewDiscord: 'Discord integrace',
      importContacts: 'Import kontaktů',
      deleteContacts: 'Mazání kontaktů',
      transferContacts: 'Převod kontaktů',
      editForecast: 'Editace forecastu',
      viewAllCompanies: 'Vidět všechny firmy',
      editOwnCompanies: 'Editace vlastních firem',
      editAllCompanies: 'Editace všech firem'
    };
    return labels[permission] || permission;
  };

  const getRoleColor = (roleName) => {
    const colors = {
      admin: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-200',
      obchodnik: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-200',
      podpora: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-200',
      callcentrum: 'bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-200',
      test: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-200'
    };
    return colors[roleName] || 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-200';
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg w-full max-w-4xl h-5/6 flex flex-col shadow-2xl`}>
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white">🎭 Editor rolí</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-2xl"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden flex">
          {/* Seznam rolí */}
          <div className="w-1/2 p-6 border-r border-gray-200 dark:border-gray-700 overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Existující role</h3>
              <button
                onClick={() => {
                  setEditingRole(null);
                  setNewRole({
                    name: '',
                    displayName: '',
                    permissions: {
                      viewAllUsers: true,
                      viewContacts: true,
                      viewChat: true,
                      viewDashboard: true,
                      viewActivities: true,
                      viewCommissions: true,
                      viewRequests: true,
                      viewAdmin: false,
                      viewBackup: false,
                      editCompanies: true,
                      deleteCompanies: false,
                      exportData: false,
                      manageUsers: false,
                      viewStatusEditor: false,
                      viewBatchVisibility: false,
                      viewKnowledge: false,
                      viewContactManagement: false,
                      viewMeetingPlanner: true,
                      editUserPermissions: false,
                      viewTransferHistory: false,
                      manageTeamleader: false,
                      viewDiscord: false,
                      importContacts: false,
                      deleteContacts: false,
                      transferContacts: false,
                      editForecast: true,
                      viewAllCompanies: true,
                      editOwnCompanies: true,
                      editAllCompanies: false
                    }
                  });
                }}
                className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm font-medium"
              >
                + Nová role
              </button>
            </div>

            {loading ? (
              <div className="text-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent mx-auto mb-2"></div>
                <p className="text-gray-600 dark:text-gray-400">Načítám role...</p>
              </div>
            ) : (
              <div className="space-y-3">
                {roles.map((role) => (
                  <div key={role.name} className={`p-3 rounded-lg border ${isDarkMode ? 'border-gray-600 bg-gray-700' : 'border-gray-200 bg-gray-50'}`}>
                    <div className="flex items-center justify-between mb-2">
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getRoleColor(role.name)}`}>
                        {role.displayName}
                      </span>
                      <div className="flex gap-1">
                        <button
                          onClick={() => handleEditRole(role)}
                          className="bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 rounded text-xs"
                        >
                          ✏️
                        </button>
                        {!['admin', 'obchodnik', 'podpora', 'callcentrum', 'test'].includes(role.name) && (
                          <button
                            onClick={() => handleDeleteRole(role.name)}
                            className="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs"
                          >
                            🗑️
                          </button>
                        )}
                      </div>
                    </div>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      Klíč: <code className="bg-gray-200 dark:bg-gray-600 px-1 rounded">{role.name}</code>
                      {['admin', 'obchodnik', 'podpora', 'callcentrum', 'test'].includes(role.name) && (
                        <span className="ml-2 text-orange-600 dark:text-orange-400">• Systémová role</span>
                      )}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
                      {Object.values(role.permissions).filter(Boolean).length} oprávnění
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Editor role */}
          <div className="w-1/2 p-6 overflow-y-auto">
            <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">
              {editingRole ? 'Editace role' : 'Nová role'}
            </h3>

            <div className="space-y-4">
              {/* Základní informace */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Klíč role (anglicky, bez mezer)
                </label>
                <input
                  type="text"
                  value={newRole.name}
                  onChange={(e) => setNewRole(prev => ({ ...prev, name: e.target.value.toLowerCase().replace(/\s/g, '') }))}
                  className={`w-full px-3 py-2 border rounded-lg ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  placeholder="napр. test, manager, viewer"
                  disabled={editingRole && ['admin', 'obchodnik', 'podpora', 'callcentrum'].includes(editingRole.name)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Zobrazovaný název
                </label>
                <input
                  type="text"
                  value={newRole.displayName}
                  onChange={(e) => setNewRole(prev => ({ ...prev, displayName: e.target.value }))}
                  className={`w-full px-3 py-2 border rounded-lg ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
                  placeholder="například: Testovací účet, Manažer"
                />
              </div>

              {/* Oprávnění */}
              <div>
                <h4 className="text-md font-medium text-gray-700 dark:text-gray-300 mb-3">Oprávnění</h4>
                <div className="grid grid-cols-1 gap-2 max-h-64 overflow-y-auto">
                  {Object.entries(newRole.permissions).map(([permission, enabled]) => (
                    <label key={permission} className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={enabled}
                        onChange={() => togglePermission(permission)}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        {getPermissionLabel(permission)}
                      </span>
                      {permission === 'viewAllUsers' && (
                        <span className="text-xs text-yellow-600 dark:text-yellow-400">
                          (⚠️ Test role: vypnout)
                        </span>
                      )}
                    </label>
                  ))}
                </div>
              </div>

              {/* Tlačítka */}
              <div className="flex gap-3 pt-4">
                <button
                  onClick={handleSaveRole}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium"
                >
                  {editingRole ? 'Uložit změny' : 'Vytvořit roli'}
                </button>
                <button
                  onClick={() => {
                    setEditingRole(null);
                    setNewRole({
                      name: '',
                      displayName: '',
                      permissions: {
                        viewAllUsers: true,
                        viewContacts: true,
                        viewChat: true,
                        viewDashboard: true,
                        viewActivities: true,
                        viewCommissions: true,
                        viewRequests: true,
                        viewAdmin: false,
                        viewBackup: false,
                        editCompanies: true,
                        deleteCompanies: false,
                        exportData: false,
                        manageUsers: false,
                        viewStatusEditor: false,
                        viewBatchVisibility: false,
                        viewKnowledge: false,
                        viewContactManagement: false,
                        viewMeetingPlanner: true,
                        editUserPermissions: false,
                        viewTransferHistory: false,
                        manageTeamleader: false,
                        viewDiscord: false,
                        importContacts: false,
                        deleteContacts: false,
                        transferContacts: false,
                        editForecast: true,
                        viewAllCompanies: true,
                        editOwnCompanies: true,
                        editAllCompanies: false
                      }
                    });
                  }}
                  className="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-lg font-medium hover:bg-gray-400 dark:hover:bg-gray-500"
                >
                  Zrušit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
